import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import { partiallyUpdateModel, Event, IsoDate } from '../definitions/Common';
import Application from './Application';


const InsLeadFormDocument = types
    .model('InsLeadFormDocument', {
        id: types.optional(types.identifier, () => uuid()),

        createdAt: types.maybe(IsoDate),
        updatedAt: types.maybe(IsoDate),
        userUpdatedAt:types.maybe(IsoDate),

        application: types.optional(Application, {}),

        events: types.array(Event),

        schemaVersion: 1,
    })
    .actions(self => ({
        trackEvent({ type, details, metadata }) {
            if (!type) {
                throw new Error('Must specify an event type');
            }

            self.events.push({
                type,
                details,
                metadata,
            });
        },
        update(values) {
            partiallyUpdateModel(self, values);
        },
    }));

export default InsLeadFormDocument;
